




import Vue from "vue";
import { toggleNav, closeScrollBounces } from "@/utils/bridge";
import { isPad, isMobile, parseParamToObj } from "@/utils/detect";
import { inBiliApp } from "@bilibili/js-bridge";
import { setStatusBarMode } from "@/utils/jsBridge";
import { checkAppBuild } from "@/utils/checkAppBuild";
const search: any = parseParamToObj(location) || {};

export default Vue.extend({
  name: "Index",
  async beforeCreate() {
    if (!search["inTest"]) {
      if ((!isMobile) || isPad) {
        // pc 或 HD(ipad和安卓Hd)
        this.$router.replace({ path: "/pcLanding", query: { ...search } });
      } else if (!inBiliApp) {
        // h5
        this.$router.replace({ path: "/mobile", query: { ...search } });
      } else {
        // 端内，是否新版app
        const isNewApp = await checkAppBuild(70900000, 7090000);
        if (isNewApp) {
          this.$router.replace({ path: "/", query: { ...search } });
        } else {
          this.$router.replace({ path: "/oldApp", query: { ...search } });
        }
      }
    }
  },
  created() {
    if (window.__Fission) {
      window.__Fission.custom({
        msg: {
          custom_key: "show",
          custom_value: search.from
        }
      });
    }
    toggleNav();
    closeScrollBounces();
    setStatusBarMode(1);
  }
});
